module.exports = __webpack_public_path__ + "static/media/gastritis-faq.d48a80e0.jpg";